const formatter = new Intl.NumberFormat('en', {minimumFractionDigits: 0, maximumFractionDigits: 3});

export default function numberFormat(x) {
    if (typeof(x) === "number") {
        return formatter.format(x);
    }
    return x.numberFormat(formatter.format);
}